// extracted by mini-css-extract-plugin
module.exports = {"log":"style_log__20AZQ","header":"style_header__2Ji3G","time":"style_time__1gqaR","info":"style_info__2zwuE","warn":"style_warn__1DjOS","error":"style_error__3bGQP"};